import React from "react";
import Canvas from './Components/Canvas';


function App() {
  return (
    <div className="bodyWrap">
      <Canvas />
    </div>
  )
}

export default App
